import { IUser, IUserGaData } from '../../types/user';
import { Action } from './actions';

export interface IUserDataState {
  profileSessionKey?: string;
  user?: IUser;
  userGaData?: IUserGaData;
}

export function userDataReducer(state: IUserDataState = {}, action: Action) {
  switch (action.type) {
    case 'IFetchUserData':
      return {
        ...state,
        user: action.user,
      };
    case 'IFetchUserGaData':
      return {
        ...state,
        userGaData: action.data,
      };
    case 'IFetchUserDataError':
    case 'IFetchUserGaDataError':
      return state;
    default:
      return state;
  }
}
